import { RootState } from "~/store/rootReducer"

export const isOpenSelector = (state: RootState) => state.snackBar.isOpen
export const titleSelector = (state: RootState) => state.snackBar.title
export const messageSelector = (state: RootState) => state.snackBar.message
export const timeoutSelector = (state: RootState) => state.snackBar.timeout
export const kindSelector = (state: RootState) => state.snackBar.KIND
